/**
 * Reorders the GLOBAL layer order from a drag inside one category section.
 *
 * The chooser shows each category's layers in global-rank order (the
 * category is just a filtered view over the one ranked list), so "move X
 * between A and B in this section" means "move X between A and B in the
 * global list": X lands right after its new upper section-neighbour (or
 * right before its new lower one when dropped at the top). Layers from
 * other categories that sit between the two neighbours globally keep their
 * positions relative to each other.
 *
 * @param globalOrder every layer code, ascending rank
 * @param sectionCodes the section's codes, in globalOrder order
 * @param from index in sectionCodes being dragged
 * @param to index in sectionCodes it was dropped on
 */
export function moveWithinSection(
  globalOrder: string[],
  sectionCodes: string[],
  from: number,
  to: number,
): string[] {
  if (from === to || from < 0 || to < 0) return globalOrder
  const moved = sectionCodes[from]

  const newSection = [...sectionCodes]
  newSection.splice(from, 1)
  newSection.splice(to, 0, moved)

  const movedAt = newSection.indexOf(moved)
  const upperNeighbour = movedAt > 0 ? newSection[movedAt - 1] : null
  const lowerNeighbour =
    movedAt < newSection.length - 1 ? newSection[movedAt + 1] : null

  const withoutMoved = globalOrder.filter((code) => code !== moved)
  const insertAt = upperNeighbour
    ? withoutMoved.indexOf(upperNeighbour) + 1
    : lowerNeighbour
      ? withoutMoved.indexOf(lowerNeighbour)
      : withoutMoved.length
  if (insertAt < 0) return globalOrder

  const next = [...withoutMoved]
  next.splice(insertAt, 0, moved)
  return next
}
